import { bootstrapApplication } from "@angular/platform-browser";
import * as Sentry from "@sentry/angular";
import {
    name,
    version,
} from "../package.json";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

Sentry.init({
    dsn: "https://ef8f341aabb679e43d28383dc930ee8b@o4504559517171712.ingest.us.sentry.io/4508091127496704",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
        Sentry.httpClientIntegration({
            // Capture HTTP client errors
            failedRequestTargets: [
                // Monitor all API requests
                /^https?:\/\//,
            ],
        }),
        // send console.log, console.warn, and console.error calls as logs to Sentry
        Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    ],
    // Tracing
    tracesSampleRate: environment.domain === "PROD" ? 0.1 : 1.0, //  Capture 10% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        "localhost",
        /^https:\/\/avocasino-portal.devsoft-kernel.com/,
        // /^https:\/\/service-avocasino-flex\.devsoft-kernel\.com\/.*/,
        /^https:\/\/avocasino-portal\.avocasino[0-9]*\.com/,
        /^https:\/\/service-avocasino-flex\.avocasino[0-9]*\.com/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: environment.domain,
    // Enable source maps
    release: `${name}@${version}`,
    attachStacktrace: true, // Attach stack traces to all messages
    enableLogs: true,
});

bootstrapApplication(AppComponent, appConfig)
    .then(() => {
        const loader = document.getElementById("app-loader");
        if (loader) {
            loader.remove();
        }
    })
    .catch((err) => console.error(err));
